export default __webpack_public_path__ + "static/media/fontello.a96b6dc5.eot";